export default {
  address: 'adress *',
  'create-account-247-support': 'Dygnet runt support',
  'create-account-secure': '100% pålitlig',
  'create-account-fast': 'Snabba och Enkla Uttag',
  'create-account-gambling-commission': 'Gambling Commission',
  // 'create-account-success-heading': 'Congratulations',
  // 'create-account-success-welcome': 'Welcome',
  // 'create-account-success-body-text': 'We’re thrilled to have you with us!',
  // 'create-account-success-bonus-claim': 'Claim your bonus',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Välkomstbonus',
  'create-account-promotion-description': `upp till ##UPTO_AMOUNT## på din första insättning`,
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Spins',

  //need translations!
  'create-account-promotion-sign-in': 'Har du redan ett konto?',
  'create-account-close': 'stänga',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Villkor tillämpas.</a> Vänligen spela ansvarsfullt. <a href="http://www.gamblingtherapy.org/sv" target="_blank">www.Gamblingtherapy.org</a>',
  // 'create-account-promotion-terms-gb': '18+. New Players only. BeGambleAware. <a href="/index.php?page=promotions&amp;scrollto=welcome_promoterms" class="ui-link">Terms Apply</a>.',

  'personal-details-title': 'Registrera',
  'personal-details-supporting-text': 'Bara 3 enkla steg',
  'address-details-title': 'Nästan där!',
  'address-details-supporting-text': 'Här går det undan!',
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'Det här är sista steget!',

  'trustly-personal-details-create-account': 'Fortsätt',

  'marketing-preferences-title': 'Preferenser för marknadsföring',
  'marketing-preferences-description':
    'Ursa Casino erbjuder sina spelare unika erbjudanden och höjdpunkter var månad, så som match bonusar, bonus spins, free spins, cashback erbjudanden, turneringar, riktiga priser, upplevelser och semestrar. För att höra om dessa vänligen gör ditt val nedan:',
  'marketing-preferences-post-text': 'Du kan när som helst ändra dina preferenser för marknadsföring på sektionen Mitt konto.',
  'marketing-preferences-label-cross-brand': 'Jag vill höra mer om exklusiva erbjudanden inom ert nätverk.',
  'marketing-preferences-label-brand-only': 'Jag vill höra mer om exklusiva erbjudanden, men enbart från ert kasino.',
  'marketing-preferences-label-email': 'Jag vill höra mer om erbjudanden via <strong>E-post</strong>',
  'marketing-preferences-label-sms': 'Jag vill höra mer om erbjudanden via <strong>SMS</strong>',
  'marketing-preferences-label-phone-call': 'Jag vill höra mer om erbjudanden via <strong>telefonsamtal</strong>',
  'marketing-preferences-label-post': 'Jag vill höra mer om erbjudanden via <strong>post</strong>',

  'marketing-preferences-unified-description':
    'Missa inte de senaste kampanjerna från Ursa Casino och de casino som hanteras <a href="/brands" target="_blank">av vårt nätverk</a>. Välj hur du vill ta emot kommunikation från oss.',
  'marketing-preferences-unified-label-email': 'E-post',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Telefonsamtal',
  'marketing-preferences-unified-label-phone-post': 'Post',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>Dygnet runt support</li><li class='one-hundred-percent-secure'>100% pålitlig</li><li class='usp-fast'>Snabba och Enkla Uttag</li></ul>",
};
